import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import "./fieldForce.css";
import back from "../../assets/back.svg";
import Tooltip from "react-bootstrap/Tooltip";
import link from "../../assets/icons/link.svg";
import Select from "react-select";
import InputField from "../../components/form/inputField/inputField";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import VersionHistoryBtn, {
  AdminButton,
} from "../../components/buttons/versionHistoryBtn";
import LinkEmpId from "../../components/buttons/linkEmpIdBtn";
import { useDispatch } from "react-redux";
import {
  designationList,
  fieldForceDetail,
  fieldForceUserEdit,
  headQuaterList,
  reportingManagerList,
} from "../../redux/actions/fieldForceAction";
import { fetchDivisionList } from "../../redux/actions/commonActions";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import LinkEmpModal from "../../components/modals/LinkEmpModal";
import { vendorDivisionList } from "../../redux/actions/productActions";
import ChangeSaved from "../../components/popups/ChangeSaved";
import ErrorMsg from "../../components/form/errorMsg";
import InputCapitalField from "../../components/form/inputField/inputCapitalField";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fieldForceData, setFieldForceData] = useState(null);
  const [linkShow, setLinkShow] = useState(false);
  const [edited, setEdited] = useState(false);
  const [editedMsg, setEditedMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  const renderLinkTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      LINK TO OTHER EMPLOYEE ID
    </Tooltip>
  );
  const params = useParams();

  const phoneRegex = /^([+]\d{2})?\d{10}$/;
  const alphaNumRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;

  const [designationOptions, setDesignationOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [headQuaterOptions, setHeadQuaterOptions] = useState([]);
  const [reportingManagerOptions, setReportingManagerOptions] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(
      fieldForceDetail(params.id, fetchFFdetailSuccess, fetchFFdetailError)
    );
    dispatch(
      designationList(fetchDesignationListSuccess, fetchDesignationListError)
    );
    dispatch(vendorDivisionList(onDevisionSuccess, onDevisionError));
    dispatch(headQuaterList(fetchHeadQuaterSuccess, fetchHeadQuaterError));
  }, []);

  useEffect(() => {
    if (selectedDivision.length > 0 && selectedLevel !== null) {
      dispatch(
        reportingManagerList(
          { division_id: selectedDivision, approval_level: selectedLevel },
          fetchReportingManagerListSuccess,
          fetchReportingManagerListError
        )
      );
    }
  }, [selectedDivision, selectedLevel]);

  const fetchFFdetailSuccess = (data) => {
    setLoading(false);
    console.log(data.data);
    setFieldForceData(data.data.data);
    setSelectedLevel(data?.data?.data?.fieldForceDesignation?.approval_level);
    setSelectedDivision(data?.data?.data?.fieldForceDivisions?.map(
      (ele) => ele?.vendorDivision?.id))
  };

  const fetchFFdetailError = (err) => {
    setLoading(false);
  };

  const fetchDesignationListSuccess = (data) => {
    setDesignationOptions(data);
  };

  const fetchDesignationListError = (err) => {
    console.log(err);
  };

  const onDevisionSuccess = (data) => {
    setDivisionList(data);
    console.log(data);
  };

  const onDevisionError = (err) => {
    console.log(err);
  };

  const fetchHeadQuaterSuccess = (data) => {
    setHeadQuaterOptions(data);
  };

  const fetchHeadQuaterError = (data) => {
    console.log(data);
  };

  const fetchReportingManagerListSuccess = (data) => {
    setReportingManagerOptions(data);
  };

  const fetchReportingManagerListError = (data) => {
    console.log(data);
  };

  const initialValues = {
    employee_id: fieldForceData?.employee_id,
    employee_name: fieldForceData?.name,
    email: fieldForceData?.email,
    country_code: "91",
    mobile: fieldForceData?.mobile,
    designation_id: fieldForceData?.designation_id,
    // division_id: fieldForceData?.division_id,
    head_quaters: fieldForceData?.fieldForceUserHeadQuaters?.map(
      (ele) => ele?.headQuater?.id
    ),
    divisions: fieldForceData?.fieldForceDivisions?.map(
      (ele) => ele?.vendorDivision?.id
    ),
    reporting_manager: fieldForceData?.reporting_manager,
  };

  const resetFunc = (setFieldValue) => {
    setFieldValue("employee_id", fieldForceData?.employee_id);
    setFieldValue("employee_name", fieldForceData?.name);
    setFieldValue("email", fieldForceData?.email);
    setFieldValue("mobile", fieldForceData?.mobile);
    setFieldValue("designation_id", fieldForceData?.designation_id);
    // setFieldValue("division_id", fieldForceData?.division_id);
    setFieldValue(
      "head_quaters",
      fieldForceData?.fieldForceUserHeadQuaters?.map(
        (ele) => ele?.headQuater?.id
      )
    );
    setFieldValue("divisions", fieldForceData?.fieldForceDivisions?.map(
      (ele) => ele?.vendorDivision?.id
    )
    );
    setFieldValue("reporting_manager", fieldForceData?.reporting_manager);
  };
  const validationSchema = Yup.object().shape({
    employee_id: Yup.string()
      .matches(alphaNumRegex, "Not a proper employee id")
      .required("Required"),
    employee_name: Yup.string().required("Required"),
    email: Yup.string().email("Not a proper email").required("Required"),
    mobile: Yup.string()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    designation_id: Yup.string().required("Required"),
    // division_id: Yup.string().required("Required"),
    head_quaters: Yup.array()
      .min(1, "At least one should be selected")
      .required("Required"),
    divisions: Yup.array()
      .min(1, "At least one should be selected")
      .required("Required"),
    // reporting_manager: Yup.string().required("Required"),
  });

  const onSubmit = (values) => {
    console.log(values);
    values["user_id"] = params.id;
    dispatch(fieldForceUserEdit(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    console.log(data);
    setEdited(true);
    const str = data.data.message;
    const modi_str = str.charAt(0).toUpperCase() + str.slice(1);
    setEditedMsg(modi_str);

    const timeOutFnc = () => {
      setEdited(false);
      navigate(`/field-force/user/view/${params.id}`);
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    { path: "/field-force/user/:1", breadcrumb: " / field force / users" },
    {
      path: "/field-force/user/edit/:id",
      breadcrumb: fieldForceData?.user_id
        ? ` / ${fieldForceData?.user_id} - edit`
        : " / edit",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ setFieldValue, values }) => (
                <Form className="">
                  <div className="search-container d-flex justify-content-between align-items-center">
                    <div
                      className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                      onClick={() => navigate(-1)}
                    >
                      <img src={back} alt="back_btn" />
                      <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                        BACK
                      </span>
                    </div>
                    <div className=" d-flex justify-content-between m-1 mb-2">
                      {/* <VersionHistoryBtn link="#" /> */}
                      <div className="d-none d-xl-block">
                        <AdminButton
                          background="#2AD3E7"
                          color="white"
                          width="300px"
                          type="button"
                          onClick={() => setLinkShow(true)}
                        >
                          <img src={link} alt="link" />
                          <span className="m-2">LINK TO OTHER EMPLOYEE ID</span>
                        </AdminButton>
                      </div>

                      <div className="d-xl-none">
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderLinkTooltip}
                        >
                          <button className="link-small-btn py-2 px-3 mx-2">
                            <img src={link} alt="link" />
                          </button>
                        </OverlayTrigger>
                      </div>
                      <AdminButton
                        background="#E7E5FF"
                        width="100px"
                        type="button"
                        onClick={() => resetFunc(setFieldValue)}
                      >
                        RESET
                      </AdminButton>
                      <AdminButton
                        background="#2AD3E7"
                        color="white"
                        width="100px"
                        type="submit"
                      >
                        <span className="m-2">SAVE</span>
                      </AdminButton>
                    </div>
                  </div>
                  <div style={{ position: "relative" }}>
                    {loading == true ? (
                      <div className="list-spinner-container">
                        <LoadingSpinnerTable />
                      </div>
                    ) : (
                      <div className="scrolling">
                        <div className="form-width ms-4 ps-3 py-1">
                          <div className="my-4 ">
                            <label className="color_747f9e fw_400 fs_14 my-1">
                              User ID
                            </label>
                            <p className="fs_16">{fieldForceData?.user_id}</p>
                          </div>
                          <div className="my-4 ">
                            <label className="color_747f9e fw_400 fs_14 my-1">
                              Field Force Code
                            </label>
                            <p className="fs_16">{fieldForceData?.code}</p>
                          </div>
                          <div className="my-4 ">
                            <InputField
                              id={"employee_id"}
                              label={"Company Employee ID"}
                              type={"text"}
                              placeholder={"Enter employee id"}
                              name={"employee_id"}
                              labelColor="color_747f9e"
                              value={values?.employee_id}
                            />
                          </div>

                          <div className="my-4">
                            <InputCapitalField
                              setFieldValue={setFieldValue}
                              id={"employee_name"}
                              label={"Employee Name"}
                              type={"text"}
                              placeholder={"Enter employee name"}
                              name={"employee_name"}
                              labelColor="color_747f9e"
                              value={values?.employee_name}
                            />
                          </div>
                          <div className="my-4">
                            <InputField
                              maxLength="10"
                              id={"mobile"}
                              label={"Phone Number"}
                              type={"text"}
                              placeholder={"Enter phone number"}
                              name={"mobile"}
                              labelColor="color_747f9e"
                              value={values?.mobile}
                            />
                          </div>
                          <div className="my-4">
                            <InputField
                              id={"email"}
                              label={"Email Address"}
                              type={"text"}
                              placeholder={"Enter email address"}
                              name={"email"}
                              labelColor="color_747f9e"
                              value={values?.email}
                            />
                          </div>
                          <div className="my-4">
                            <label className="color_747f9e fw_400 fs_14 my-1">
                              Designation
                            </label>
                            <Field>
                              {({ form, Field }) => (
                                <Select
                                  options={designationOptions}
                                  styles={customStyles}
                                  {...Field}
                                  placeholder={"Select Role"}
                                  id="designation_id"
                                  value={designationOptions.filter(
                                    (c) => c.value == values?.designation_id
                                  )}
                                  onChange={(selectedOption) => {
                                    setSelectedLevel(
                                      selectedOption?.approval_level
                                    );
                                    form.setFieldValue(
                                      "designation_id",
                                      selectedOption.value
                                    );
                                  }}
                                />
                              )}
                            </Field>
                          </div>
                          {selectedLevel != "admin" && (
                            <>
                              <div className="my-2">
                                <label className="color_747f9e fw_400 fs_14 my-1">
                                  Division Name
                                </label>
                                {/* <Field>
                                  {({ form, Field }) => (
                                    <Select
                                      options={divisionList}
                                      styles={customStyles}
                                      {...Field}
                                      placeholder={"Select Division"}
                                      id="division_id"
                                      value={divisionList.filter(
                                        (c) => c.value == values?.division_id
                                      )}
                                      onChange={(selectedOption) => {
                                        setSelectedDivision(
                                          selectedOption?.value
                                        );
                                        form.setFieldValue(
                                          "division_id",
                                          selectedOption.value
                                        );
                                      }}
                                    />
                                  )}
                                </Field>
                                <ErrorMsg name="division_id" /> */}
                                <Field>
                                  {({ form, Field }) => (
                                    <Select
                                      isMulti
                                      options={divisionList}
                                      styles={customStyles}
                                      {...Field}
                                      placeholder={"Select Division"}
                                      id="divisions"
                                      value={divisionList.filter((o1) =>
                                        values?.divisions?.some(
                                          (o2) => o2 == o1.value
                                        )
                                      )}
                                      onChange={(selectedOption) => {
                                        setSelectedDivision(
                                          selectedOption
                                            ? selectedOption.map(
                                              (item) => item.value
                                            )
                                            : []
                                        );
                                        form.setFieldValue(
                                          "divisions",
                                          selectedOption
                                            ? selectedOption.map(
                                              (item) => item.value
                                            )
                                            : []
                                        );
                                      }}
                                    />
                                  )}
                                </Field>
                                <ErrorMsg name="divisions" />
                              </div>
                              <div>
                                <div className="my-2">
                                  <label className="color_747f9e fw_400 fs_14 my-1">
                                    Head Quaters
                                  </label>

                                  <Field>
                                    {({ form, Field }) => (
                                      <Select
                                        isMulti
                                        options={headQuaterOptions}
                                        styles={customStyles}
                                        {...Field}
                                        placeholder={"Select Areas"}
                                        id="head_quaters"
                                        value={headQuaterOptions.filter((o1) =>
                                          values?.head_quaters?.some(
                                            (o2) => o2 == o1.value
                                          )
                                        )}
                                        onChange={(selectedOption) => {
                                          form.setFieldValue(
                                            "head_quaters",
                                            selectedOption
                                              ? selectedOption.map(
                                                (item) => item.value
                                              )
                                              : []
                                          );
                                        }}
                                      />
                                    )}
                                  </Field>
                                  <ErrorMsg name="head_quaters" />

                                </div>
                              </div>
                              <div className="my-2 mb-5">
                                <label className=" color_747f9e fw_400 fs_14 my-1">
                                  Reporting Manager
                                </label>

                                <Field>
                                  {({ form, Field }) => (
                                    <Select
                                      options={reportingManagerOptions}
                                      styles={customStyles}
                                      {...Field}
                                      placeholder={
                                        "Select reporting manager / Superior"
                                      }
                                      id="reporting_manager"
                                      name="reporting_manager"
                                      onChange={(selectedOption) => {
                                        form.setFieldValue(
                                          "reporting_manager",
                                          selectedOption.value
                                        );
                                      }}
                                      value={reportingManagerOptions.filter(
                                        (c) => c.value == values?.reporting_manager
                                      )}
                                    />
                                  )}
                                </Field>
                                <ErrorMsg name="reporting_manager" />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <ChangeSaved show={edited} title={editedMsg} />
        <LinkEmpModal
          show={linkShow}
          handleClose={() => setLinkShow(false)}
          user_id={fieldForceData?.user_id}
          employee_id={fieldForceData?.employee_id}
          field_force_id={params.id}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default FieldForceEdit;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    // height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
